var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"dashboard__container"},[(_vm.user)?_c('div',{staticClass:"dashboard__container--body"},[(_vm.iframaData && (_vm.iframaData != null))?_c('iframe',{attrs:{"src":_vm.iframaData}}):_vm._e()]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }